import * as PopperJS from 'popper.js'
import * as React from 'react'
import { Arrow, Manager, Popper, Target } from 'react-popper'

import './OverlayTrigger.scss'

export interface IExternalProps {
  overlay: string | JSX.Element
  children: JSX.Element
  placement: PopperJS.Placement
  show?: boolean // logic of when and how to show should be handled in parent
  hideArrow?: boolean // True if arrow not needed
  popperClassName?: string // For popper element
  arrowClassName?: string // For arrow element
}
const className = 'OverlayTrigger'

const OverlayTrigger = (props: IExternalProps) => {
  const { popperClassName, arrowClassName, children, show, overlay, hideArrow, placement } = props
  return (
    <Manager>
      <Target>
        {({ targetProps }) => {
          return React.cloneElement(children, { ref: targetProps.ref })
        }}
      </Target>
      {show && (
        <Popper placement={placement} className={`${className} ${popperClassName || ''}`}>
          {overlay}
          {!hideArrow && <Arrow className={`${className}__arrow ${arrowClassName || ''}`} />}
        </Popper>
      )}
    </Manager>
  )
}

export default OverlayTrigger
